export type CollectionItemsAction = "buy" | "sell"
export const CollectionItemsAction = [
  "buy",
  "sell",
] as const satisfies CollectionItemsAction[]

type CollectionItemsActionMode = "automatic" | "manual"

export type CollectionItemsActionState = {
  mode: CollectionItemsActionMode
  desiredNumberOfItems: number
}
